export const camelCaseToSentenceCase = (str) =>
  str.trim().replace(/([A-Z])/g, " $1").replace(/^./, (str) => str.toUpperCase());

export const trimEmail = (email) => {
  const emailArr = email?.split("@");
  return emailArr?.[0];
};
